<div id="modal-content-wrapper">
    <div class="modal"> 
        <div #modal  class="modal-content"  [style]="message?.style" >
            <div class="modal-body">
              <ng-container  *ngTemplateOutlet="message?.template"></ng-container>
          </div>
     </div> 
</div>
</div>